import Checkbox from "../form/input/Checkbox";
import Label from "../form/Label";

export interface PixelEvents {
    initiateCheckout: boolean;
    purchase: boolean;
}

/**
 * Quais eventos o pixel envia: só InitiateCheckout, só Purchase ou os dois.
 * Pelo menos um precisa ficar marcado (o backend recusa os dois desmarcados).
 */
export default function PixelEventsField({
    value,
    onChange,
    error,
}: {
    value: PixelEvents;
    onChange: (value: PixelEvents) => void;
    error?: string;
}) {
    return (
        <div className="mt-5">
            <Label>Eventos enviados *</Label>
            <div className="flex flex-col gap-3 mt-2">
                <Checkbox
                    id="event-initiate-checkout"
                    label="InitiateCheckout — quando o comprador abre o checkout"
                    checked={value.initiateCheckout}
                    onChange={checked => onChange({ ...value, initiateCheckout: checked })}
                />
                <Checkbox
                    id="event-purchase"
                    label="Purchase — quando o pagamento é aprovado"
                    checked={value.purchase}
                    onChange={checked => onChange({ ...value, purchase: checked })}
                />
            </div>
            {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
        </div>
    );
}
